import { useTranslation } from 'react-i18next';

import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.js';
import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.js';
import { Alert } from '@sola/ark-core/molecules/alert/alert.js';
import { ErrorCart } from '@sola/schema/dotcom/cart/errors.js';
import { ChildDetails } from '@sola/schema/dotcom/children/child.js';
import { trackError } from '@sola/tracking/components/datalayer.js';

// TODO: Refactor to use for other calls to add items to the cart?
const BioErrors: React.FC<{ errors: ErrorCart[] }> = ({ errors }) => {
  const { t, i18n } = useTranslation(['checkout', 'common', 'bio']);
  const errorTypesDisplayed: string[] = [];
  const errorsToDisplay = errors.reduce((displayErrors: ErrorCart[], err) => {
    if (!errorTypesDisplayed.includes(err.type)) {
      errorTypesDisplayed.push(err.type);
      return [...displayErrors, err];
    }
    return displayErrors;
  }, []);
  return (
    <div className="flex flex-col gap-y-snug-xl mb-comfy-xl">
      {errorsToDisplay.map((error) => {
        trackError(JSON.stringify(error));
        // We may want to provide UI-specific properties in our error objects, but keeping things simple for now.
        const { type, severity } = error;
        const elKey = error.id;
        // TODO: Refactor cart errors out of checkout
        const hasMsg = i18n.exists(`checkout:errors.${type}.message`);
        const hasTitle = i18n.exists(`checkout:errors.${type}.title`);
        const message = hasMsg ? (
          <IntlBlock
            i18nKey={`checkout:errors.${type}.message`}
            values={error}
            tOptions={{
              interpolation: {
                escapeValue: false,
              },
            }}
            components={{
              // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
              anchor: <a />,
            }}
          />
        ) : (
          // TODO: Refactor cart errors out of checkout
          t(`checkout:errors.CART_GENERIC.message`)
        );
        const title = hasTitle ? (
          <IntlBlock
            i18nKey={`checkout:errors.${type}.title`}
            values={error}
            tOptions={{
              interpolation: {
                escapeValue: false,
              },
            }}
          />
        ) : undefined;

        return (
          (hasMsg || hasTitle) && (
            <Alert
              key={elKey}
              variant={severity ?? 'negative'}
              title={hasTitle && title}
              message={hasMsg && message}
              dismissible={false}
            />
          )
        );
      })}
    </div>
  );
};

export const SubmitButton = ({
  bioErrors,
  className,
  details,
  isSubmitting,
  handleSponsorshipSubmit,
}: {
  details: ChildDetails;
  isSubmitting: boolean;
  handleSponsorshipSubmit: () => Promise<void>;
  className?: string;
  bioErrors?: ErrorCart[];
}) => {
  const { t } = useTranslation(['bio']);
  return (
    <div className={className}>
      {bioErrors && <BioErrors errors={bioErrors} />}
      <ButtonStyle variant="primary" isBusy={isSubmitting}>
        <button
          id="add-cdsp"
          className="w-full md:w-fit"
          type="button"
          onClick={handleSponsorshipSubmit}
        >
          {isSubmitting
            ? `${t('bio:processing')}...`
            : t('bio:sponsorButton', {
                childName: details.name.preferred,
                koreanName: details.hangul.preferred || details.name.preferred,
              })}
        </button>
      </ButtonStyle>
    </div>
  );
};
